import { useState, useEffect, useRef, useCallback } from 'react'
import '../inquiry/telephonic/telephonic.scss'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../components/button/Button'
import { useNavigate } from 'react-router-dom'
import { numbers, permissions, ROUTES_PATH, statuses, UI_CONSTANT } from '../../utility/constants'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import HorizontalLine from '../../assets/icons/Line33.svg'
import pencilicon from '../../assets/icons/pencil1.svg'
import archive from '../../assets/icons/archive.svg'
import transferIcon from '../../assets/icons/transferIcon.svg'
import '../course/viewCourseList.scss'
import './enrollmentList.scss'
import PopupBox from '../../components/popup/PopupBox'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import closeIcon from '../../assets/icons/close.svg'
import { ErrorMessage, Formik } from 'formik'
import * as Yup from 'yup'
import RightDrawer from '../../components/drawer/Drawer'
import ModalUnstyled from '../../components/model/Model'
import TableDateInput from '../../components/table-date-input/TableDateInput'
import {
  archiveEnrollment,
  getEnrollment,
  transferBatchOrBranch,
} from '../../store/builders/enrollment/enrollment.builder'
import { capitalizeFirstLetter } from '../../utility/genricFunction'
import { Dropdown } from 'primereact/dropdown'
import ServerParentDataTable from '../../components/data-table/ServerParentDataTable'
import { getBatch } from '../../store/builders/branch/branch.builder'
import { getBatchList, getCourseBranchFees } from '../../store/builders/course/course.builder'
import { VALIDATION_MESSAGES } from '../../utility/constantValidationMessages'

import UseAuthorization from '../../utility/useAuthorization'
import Loader from '../../components/loader/Loader'
import apiClient from '../../services/axois'
import { DrawerList } from '../../components/enrollmentDrawer/DrawerList'
import FromToDatePicker from '../../components/from-to-datePicker/FromToDatePicker'
import { setDateFrom, setDateTo } from '../../store/slice/inquiry/inquiry.slice'

const Enrollment = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const branchList = useSelector((store) => store.branch.branchTableData)
  const roleSelector = useSelector((store) => store.auth)
  const { dateFrom, dateTo } = useSelector((state) => state.inquiry)
  const userRole = roleSelector?.user?.result?.userData?.roleName
  const { loading, enrollmentData, enrollmentPageData } = useSelector((state) => state.enrollment)
  const batchList = useSelector((store) => store?.branch?.batchData)
  const batchListDropdown = useSelector((store) => store?.course?.batchList)
  const [open, setOpen] = useState(false)
  const [branchState, setBranchState] = useState('')
  const [batchState, setBatchState] = useState('')
  const [page, setPage] = useState(1)
  const [feesData, setFeesData] = useState()
  const batchOption = useRef([])
  const [isOpen, setIsOpen] = useState(false)
  const [archiveId, setArchiveId] = useState('')
  const [enrollData, setEnrollData] = useState('')
  const [batchOptionList, setBatchOptionList] = useState([])
  const [openArchive, setOpenArchive] = useState(false)
  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)
  const [selectedValue, setSelectedValue] = useState(null)
  const [filters, setFilters] = useState({})

  const checkFessData = useCallback(() => {
    if (feesData?.courseId) {
      dispatch(
        getCourseBranchFees({
          courseId: feesData?.courseId,
          batchId: feesData?.batchId,
          branchId: feesData?.branchId,
          studentId: feesData?.studentId,
        }),
      )
    }
    const batch = batchList?.result?.batches
      ?.filter((batch) => {
        return batch.branchId === branchState
      })
      .map((batchData) => {
        return { label: batchData.batchNo, value: batchData.batchId }
      })

    batchOption.current = batch?.length ? batch : []
  }, [feesData])

  useEffect(() => {
    checkFessData()
  }, [feesData])

  const toggleDrawer = (newOpen) => {
    setOpen(newOpen)
    setIsOpen(true)
  }

  const handleFormSubmit = (data) => {
    setOpen(false)
    dispatch(transferBatchOrBranch(data))
  }

  // const handleBranchDropdown = (e, setFieldValue) => {
  //   e.preventDefault()
  //   const branchValue = e.target.value
  //   setFieldValue('branch', branchValue)
  //   console.log(branchValue, "current selected branch")
  //   dispatch(getBatchList({ value: branchValue,courseId: feesData?.courseId }))
  // }

  const getBatchOptionList = async (branchId, courseId) => {
    const url = `/branch/batch/${branchId}/${courseId}`

    const response = await apiClient.get(url)
    const batches = response.data.result.Batch.map((batch) => {
      return {
        batchId: batch.batchId,
        batchNo: batch.batchNo,
      }
    })

    setBatchOptionList(batches)
  }
  const handleBranchDropdown = async (e, setFieldValue) => {
    e.preventDefault()
    const branchValue = e.target.value

    // Update branch state
    setFieldValue('branch', branchValue)

    // Fetch batch list
    getBatchOptionList(branchValue, feesData?.courseId)
  }

  useEffect(() => {
    const batch = batchListDropdown?.result?.batche.map((batchData) => {
      return { label: batchData.batchNo, value: batchData.batchId }
    })

    batchOption.current = batch?.length ? batch : []
  }, [batchListDropdown])

  useEffect(() => {
    setFeesData(enrollData)
    setBranchState(enrollData?.branchId)
    setBatchState(enrollData?.batchId)
  }, [enrollData])

  const handleChangePageLimit = (e) => {
    setSelectedNumber(Number(e.value))
    setPage(1)
  }

  useEffect(() => {
    const newFilters = { ...filters }
    newFilters.limit = {
      value: selectedNumber,
      matchMode: 'startsWith',
    }

    newFilters.page = {
      value: page,
      matchMode: 'startsWith',
    }

    const keysToIgnore = ['limit', 'page']
    const areAllOtherKeysNull = Object.keys(filters).every(
      (key) => keysToIgnore.includes(key) || filters[key].value === null || filters[key].value === '',
    )

    if (areAllOtherKeysNull) {
      dispatch(getEnrollment(newFilters))
    } else {
      Object.keys(filters).length && dispatch(getEnrollment(filters))
    }
    return () => dispatch({ type: 'enrollment/clearExtraReducers' })
  }, [filters, selectedNumber, page, dispatch])

  useEffect(() => {
    if (dateFrom === undefined) {
      filters.enrollment_date_from = {
        value: undefined,
        matchMode: 'startsWith',
      }
    }

    if (dateTo === undefined) {
      filters.enrollment_date_to = {
        value: undefined,
        matchMode: 'startsWith',
      }
    }
    const newFilters = { ...filters }

    newFilters.limit = {
      value: selectedNumber,
      matchMode: 'startsWith',
    }

    newFilters.page = {
      value: page,
      matchMode: 'startsWith',
    }
    if (dateFrom === undefined) {
      dispatch(getEnrollment(newFilters))
    }
    if (dateTo === undefined) {
      dispatch(getEnrollment(newFilters))
    }
    let enrollFrom = '',
      enrollTo = ''
    if (dateFrom !== '' && dateFrom !== undefined) {
      const date = new Date(dateFrom)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0') // Pad with leading zero if necessary
      const day = String(date.getDate()).padStart(2, '0')
      enrollFrom = `${year}-${month}-${day}`
    }

    if (dateTo !== '' && dateTo !== undefined) {
      const date2 = new Date(dateTo)
      date2.setDate(date2.getDate() + 1)
      const year2 = date2.getFullYear()
      const month2 = String(date2.getMonth() + 1).padStart(2, '0') // Pad with leading zero if necessary
      const day2 = String(date2.getDate()).padStart(2, '0')
      enrollTo = `${year2}-${month2}-${day2}`
    }
    filters.enrollment_date_from = {
      value: enrollFrom,
      matchMode: 'startsWith',
    }

    filters.enrollment_date_to = {
      value: enrollTo,
      matchMode: 'startsWith',
    }
    if (enrollFrom !== '' && enrollTo !== '') {
      dispatch(getEnrollment(filters))
    }
  }, [dateFrom, dateTo])

  // const apiCallOnPagination = useCallback(()=> {
  //   const newFilters = { ...filters }

  //   newFilters.limit = {
  //     value: selectedNumber,
  //     matchMode: 'startsWith',
  //   }

  //   newFilters.page = {
  //     value: page,
  //     matchMode: 'startsWith',
  //   }

  //   dispatch(getEnrollment(newFilters))

  // },[selectedNumber,page])

  useEffect(() => {
    dispatch(getBatch())
    dispatch(setDateFrom(''))
    dispatch(setDateTo(''))
  }, [])

  // useEffect(() => {
  //   apiCallOnPagination()
  // }, [selectedNumber, page])

  const handleArchive = () => {
    setOpenArchive(true)
    setIsOpen(true)
    setArchiveId()
  }

  const handleEnrollmentArchive = (studentId) => {
    dispatch(archiveEnrollment(studentId))
    setOpenArchive(false)
  }

  const verifiedBodyTemplate = (enrollmentData) => {
    const handleRowClick = (id) => {
      const path = enrollmentData.userStatus === 'inactive' ? `${ROUTES_PATH.ADD_ENROLLMENT}?oldEnrollment=${id}` : ROUTES_PATH.EDIT_ENROLLMENT.replace(':id', id)
      navigate(path)
    }
    return (
      <>
        <PopupBox rowData={enrollmentData} setIsOpen={setIsOpen} isOpen={isOpen}>
          <div className='popupbox'>
            {UseAuthorization(permissions.TRANSFER_BATCH_OR_BRANCH)  && (
              <>
                <p className='verifiedBodyTemplate-Assign'>ACTION</p>
                {/* <img src={HorizontalLine} alt='' /> */}
                <button
                  className='div-assign-to-branch'
                  disabled={enrollmentData?.userStatus == 'archive' || enrollmentData?.userStatus == 'inactive' ? true : false}
                  onClick={() => {
                    toggleDrawer(true)
                    setEnrollData(enrollmentData)
                    setArchiveId(enrollmentData.studentId)
                  }}
                >
                  <img src={transferIcon} alt='' />{' '}
                  <p
                    className={`${enrollmentData?.userStatus == 'archive' ||  enrollmentData?.userStatus == 'inactive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                  >
                    Transfer Batch {'/'} Branch
                  </p>
                </button>
              </>
            )}

            {(UseAuthorization(permissions.EDIT_ENROLLMENT) && <img src={HorizontalLine} alt='' />) ||
              (UseAuthorization(permissions.ARCHIVE_ENROLLMENT) && <img src={HorizontalLine} alt='' />)}

            {UseAuthorization(permissions.EDIT_ENROLLMENT) && (
              <button
                className='div-assign-to-branch'
                disabled={enrollmentData?.userStatus == 'archive' ||  enrollmentData?.userStatus == 'inactive' ? true : false}
                onClick={() => handleRowClick(enrollmentData.studentId)}
              >
                <img src={pencilicon} alt='' />{' '}
                <p
                  className={`${enrollmentData?.userStatus == 'archive' ||  enrollmentData?.userStatus == 'inactive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                >
                  Edit
                </p>
              </button>
            )}
            {UseAuthorization(permissions.EDIT_ENROLLMENT) && (
              <button
                className='div-assign-to-branch'
                disabled={enrollmentData?.userStatus == 'archive' ||  enrollmentData?.userStatus !== 'inactive' ? true : false}
                onClick={() => handleRowClick(enrollmentData.studentId)}
              >
                <img src={pencilicon} alt='' />{' '}
                <p
                  className={`${enrollmentData?.userStatus == 'archive' ||  enrollmentData?.userStatus !== 'inactive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                >
                  Enroll New Course
                </p>
              </button>
            )}

            {UseAuthorization(permissions.ARCHIVE_ENROLLMENT) && (
              <button
                className='div-assign-to-branch'
                disabled={enrollmentData?.userStatus == 'archive' || enrollmentData?.userStatus == 'inactive' ? true : false}
                onClick={() => handleArchive(enrollmentData.studentId)}
              >
                <img src={archive} alt='' />{' '}
                <p
                  className={`${enrollmentData?.userStatus == 'archive' ||  enrollmentData?.userStatus == 'inactive' ? 'verifiedBodyTemplate-darkfont popup-font' : 'verifiedBodyTemplate-darkfont'}`}
                >
                  Archive
                </p>
              </button>
            )}
          </div>
        </PopupBox>

        {openArchive && (
          <ModalUnstyled
            open={openArchive}
            setOpen={setOpenArchive}
            title={'Archive'}
            BottomButton={'Yes'}
            className={'archive-model'}
            BottomButton2={'No'}
            backgroundColor='rgb(0 0 0 / 0.1)'
            onYes={() => {
              handleEnrollmentArchive(archiveId)
            }}
          >
            <div className='model-archive'>
              <p>{UI_CONSTANT.ARCHIVE_MESSAGE}</p>
            </div>
          </ModalUnstyled>
        )}
      </>
    )
  }

  const statusRowFilterTemplate = (options) => {
    const onDropdownChange = (e) => {
      setSelectedValue(e.value)
      options.filterApplyCallback(e.value)
    }
    return (
      <Dropdown
        value={selectedValue}
        options={statuses}
        onChange={onDropdownChange}
        // itemTemplate={statusItemTemplate}
        placeholder='All'
        className='p-column-filter'
        optionLabel='label'
        showClear
        // style={{ minWidth: '12rem' }}
      />
    )
  }

  const nameBody = (enrollmentData) => {
    const representative = enrollmentData?.userName && capitalizeFirstLetter(enrollmentData?.userName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const courseBody = (enrollmentData) => {
    const representative = enrollmentData?.courseName && capitalizeFirstLetter(enrollmentData?.courseName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const branchBody = (enrollmentData) => {
    const representative = enrollmentData?.branchName && capitalizeFirstLetter(enrollmentData?.branchName)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const statusBody = (enrollmentData) => {
    const representative = enrollmentData?.userStatus && capitalizeFirstLetter(enrollmentData?.userStatus)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  const columns = [
    {
      sortable: true,
      field: 'userName',
      header: 'Name',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBody,
    },
    {
      sortable: true,
      field: 'userPhone',
      header: 'Mobile',
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by mobile...',
    },
    {
      sortable: true,
      field: 'enrollmentDate',
      header: 'Registration Date',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by date...',
      filterElement: FromToDatePicker,
      // filterElement: TableDateInput,
    },
    {
      sortable: true,
      field: 'courseName',
      header: 'Course Name',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by course...',
      body: courseBody,
    },
    {
      sortable: true,
      field: 'batchNo',
      header: 'Batch',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by batch...',
    },
    {
      sortable: true,
      field: 'branchName',
      header: 'Branch',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by branch...',
      body: branchBody,
    },
    {
      sortable: true,
      field: 'userStatus',
      header: 'Status',
      showFilterMenu: false,
      filterMenuStyle: { minWidth: '5rem' },
      style: { minWidth: '10rem' },
      body: statusBody,
      filter: true,
      filterElement: statusRowFilterTemplate,
    },
    {
      sortable: false,
      field: 'verified',
      header: '',
      dataType: 'boolean',
      style: { maxWidth: '4rem' },
      body: verifiedBodyTemplate,
      filter: false,
    },
  ].filter((column) => {
    if (column.field.toLowerCase() == 'branch' && userRole.toLowerCase() == UI_CONSTANT.BRANCH_ROLE) {
      return false
    } else {
      return true
    }
  })

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.ENROLLMENT.LABEL_ENROLLMENT,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.DASHBOARD,
    },
    {
      title: UI_CONSTANT.ENROLLMENT.LABEL_ENROLLMENT,
      link: ROUTES_PATH.ENROLLMENT,
    },
  ]
  let timer
  const onFilterChange = (e) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      setFilters(e.filters)
    }, 1000)
  }

  // if(!loading){
  //   // return <Loader/>
  // } else
  return (
    <>
      {/* <div className={`telephonic-container flex flex-column`}> */}
      {loading && <Loader loading={loading} />}

      {<Loader loading={loading} /> && (
        <div className={`course-list }`}>
          <div className='filter-bar-wraper'>
            <div className='subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />

              {/* <Button className='add-btn' onClick={handleAddEnrollment}>
              Add Enrollment
            </Button> */}
            </div>
          </div>

          <div className='group-parent'>
            <div className='frame-wrapper'>
              <div className='course-list-wrapper'>
                <b className='course-list1'>{UI_CONSTANT.ENROLLMENT.ALL_ENROLLMENT}</b>
              </div>
            </div>
            <div className='flex page-drop-div'>
              <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
              <PageDropdown
                options={numbers}
                selectedValue={selectedNumber}
                onChange={(e) => handleChangePageLimit(e)}
                className='w-full md:w-14rem small-dropdown'
              />
              <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
            </div>
            <div className='table-card action-btn-include'>
              <ServerParentDataTable
                value={enrollmentData}
                rows={selectedNumber}
                filters={filters}
                // loading={loading}
                columns={columns}
                archiveKey={'userStatus'}
                onFilter={onFilterChange}
                isServerSide={true}
                pageChange={(e) => setPage(Number(e.page) + 1)}
                totalRecords={enrollmentPageData?.totalItems}
              />
            </div>
          </div>

          {/* </div> */}
          {open && (
            <RightDrawer anchor='right' isOpen={open} onClose={() => toggleDrawer(false)}>
              <DrawerList enrollData={enrollData} studentId={archiveId} toggleDrawer={toggleDrawer} setOpen={setOpen} />
            </RightDrawer>
          )}
        </div>
      )}
    </>
  )
}

export default Enrollment
